var _g;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function Svg4Icon32PxGlobe(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 32,
    height: 32,
    fill: "currentColor",
    viewBox: "0 0 32 32",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    className: "4-icon-32-px-globe"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "currentColor",
    fillRule: "evenodd",
    d: "M16 4C9.373 4 4 9.373 4 16s5.373 12 12 12 12-5.373 12-12S22.627 4 16 4zm-2.273 2.26A10.008 10.008 0 006.049 15h4.599a17.832 17.832 0 013.079-8.74zm4.546 0a17.83 17.83 0 013.08 8.74h4.598a10.007 10.007 0 00-7.678-8.74zM19.346 15A15.83 15.83 0 0016 6.544 15.83 15.83 0 0012.654 15h6.692zm-6.692 2h6.692A15.83 15.83 0 0116 25.456 15.831 15.831 0 0112.654 17zm-2.006 0H6.049a10.008 10.008 0 007.678 8.74 17.832 17.832 0 01-3.08-8.74zm7.625 8.74a17.83 17.83 0 003.08-8.74h4.598a10.008 10.008 0 01-7.678 8.74z",
    className: "\\xF0\\x9F\\x8E\\xA8 Color",
    clipRule: "evenodd"
  }))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(Svg4Icon32PxGlobe);
export default __webpack_public_path__ + "static/media/4-icon-32-px-globe.cd6ed621.svg";
export { ForwardRef as ReactComponent };